import { MessageCircle } from "lucide-react";

const WA_NUMBER = "5511996420785";
const WA_TEXT = "Olá! Preciso de ajuda com o RotaSaúde.";

export const WhatsAppHelp = () => (
  <a
    className="wa-help-fab"
    href={`https://wa.me/${WA_NUMBER}?text=${encodeURIComponent(WA_TEXT)}`}
    target="_blank"
    rel="noopener noreferrer"
    aria-label="Ajuda pelo WhatsApp"
    data-testid="whatsapp-help-button"
  >
    <MessageCircle size={20} strokeWidth={2.4} />
    <span>Ajuda</span>
  </a>
);
